<template>
  <header class="site-header">
    <Navbar />
    <div class="logo-container">
      <router-link :to="'/'" class="no-style" exact>
        <PictureLoader src="/static/img/logo.png" lazy="false" class="logo"/>
      </router-link>
    </div>
  </header>
</template>
<script>
import Navbar from './Navbar'
import PictureLoader from './PictureLoader'

export default {
  name: 'header',
  components: {
    Navbar,
    PictureLoader
  },
  methods: {
    click () {
      // do nothing
    }
  }
}
</script>



// WEBPACK FOOTER //
// Header.vue?02f1d79e